import { render, staticRenderFns } from "./AddWorkOrder.vue?vue&type=template&id=72a45ac0&scoped=true"
import script from "./AddWorkOrder.vue?vue&type=script&lang=ts"
export * from "./AddWorkOrder.vue?vue&type=script&lang=ts"
import style0 from "./AddWorkOrder.vue?vue&type=style&index=0&id=72a45ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a45ac0",
  null
  
)

export default component.exports